import React from "react";

export default function Header() {
    return (
        <div className="header">
            <h1 className="header--title">Tenzies</h1>
            <p className="header--instructions">Roll until all dice are the same. Click each die to freeze it at its current value between rolls.</p>
        </div>
    )
}